module.exports = __webpack_public_path__ + "officialStatic/img/small5.463ac06.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/wireless/small5.png
// module id = pojq
// module chunks = 0